import { Routes } from "@angular/router";
import { QuotationNotificationSettingsRoutePaths } from "./quotation-notification-settings-paths";
import { quotationNotificationSettingsResolver } from "./resolver/quotation-notification-settings.resolver";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";
import { IAuthGuardOptions } from "@app/shared/auth/interfaces/auth.interface";
import { NotificationSettingsRoutePaths } from "@app/applications/settings/domains/notification-settings/notification-settings-route-path";

const authGuardOptions: IAuthGuardOptions = {
  permissions: [
    ...COMMON_GUARD_OPTIONS.QUOTATION_NOTIFICATION_SETTINGS.GET.permissions,
    ...COMMON_GUARD_OPTIONS.QUOTATION_NOTIFICATION_SETTINGS.SET.permissions,
  ],
  redirectTo: `/${NotificationSettingsRoutePaths.BASE_URL}`,
};

export const quotationNotificationSettingsRoutes: Routes = [
  {
    path: QuotationNotificationSettingsRoutePaths.ROOT,
    loadComponent: () =>
      import("./pages/quotation-notification-settings/quotation-notification-settings.component").then(t => t.QuotationNotificationSettingsComponent),
    resolve: {
      quotationNotificationSettings: quotationNotificationSettingsResolver,
    },
    canActivate: [AuthGuard],
    data: { authGuardOptions },
  },
];
